<div class="ptf-layout" *ngIf="loadedForm">

  <!-- ── Panel izquierdo: formulario ───────────────────────────────────────── -->
  <div class="ptf-form-panel">

    <div class="config-card">
      <div class="cc-page-header cc-page-header--form">
        <div class="cc-page-header-title">
          <i class="pi pi-table"></i>
          <span>{{ title | translate }}</span>
        </div>
      </div>

      <div class="config-body">

        <section class="form-section">
          <h4 class="section-title">{{ 'FASCICLE.SECTION_BASIC' | translate }}</h4>
          <form [formGroup]="form">
            <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
          </form>
        </section>

        <section class="form-section">
          <h4 class="section-title">{{ 'PAGE.IMAGE' | translate }}</h4>
          <input
            #fileInput
            type="file"
            accept="image/*"
            class="hidden"
            (change)="onFileSelected($event)"
          />
          <div class="ptf-image-row">
            <p-button
              icon="pi pi-image"
              [label]="'PAGE.SELECT_IMAGE' | translate"
              severity="secondary"
              [outlined]="true"
              size="small"
              (onClick)="fileInput.click()"
            ></p-button>
            <span class="ptf-image-name">
              {{ imageName || ('PAGE.NO_IMAGE' | translate) }}
            </span>
          </div>
        </section>

      </div>
    </div>

    <!-- Acciones -->
    <div class="ptf-actions">
      <p-button
        icon="pi pi-save"
        [label]="'FORM.SAVE' | translate"
        severity="primary"
        size="small"
        [disabled]="!form.valid"
        (onClick)="save()"
      ></p-button>
      <p-button
        icon="pi pi-times"
        [label]="'FORM.CANCEL' | translate"
        severity="secondary"
        [outlined]="true"
        size="small"
        (onClick)="cancel()"
      ></p-button>
    </div>

  </div>

  <!-- ── Panel derecho: preview A4 ─────────────────────────────────────────── -->
  <div class="ptf-preview-panel">
    <div class="ptf-preview-wrapper">
      <app-page-template-example
        [cols]="exampleCols > 0 ? exampleCols : 1"
        [rows]="exampleRows > 0 ? exampleRows : 1"
        [cells]="model.cells"
        (modifiedCells)="modifiedCells($event)"
        [imageSrc]="imageSrc"
        [locked]="false"
        style="width: 100%; height: 100%; display: block;"
      ></app-page-template-example>
    </div>
  </div>

</div>
